import React from 'react';
import { FormattedHTMLMessage } from 'react-intl';
import Section from '../components/Section';

export default () => (
  <Section id="company">
    <h1><FormattedHTMLMessage id="pages:company:title" /></h1>
    <FormattedHTMLMessage id="pages:company:description" />
  </Section>
);



// WEBPACK FOOTER //
// ./src/sections/Company.js